<div class="segment time time-row-align">
  <input
    #timeInput
    type="time"
    [value]="timeInputValue"
    [placeholder]="self.TIME_PLACEHOLDER"
    [disabled]="disabled"
    (change)="onTimeInputChange($event)"
    (blur)="onTimeInputBlur($event)"
    class="time-native-input"
    [style.text-align]="textAlign"
  />
</div>
